import { Component, OnInit } from '@angular/core';
import { EmrModalComponent, GetHistoryTripRequest } from 'emr-ng-shared';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ShowViewlogComponent } from '../show-viewlog/show-viewlog.component';

@Component({
  selector: 'app-show-viewlog-popup',
  templateUrl: './show-viewlog-popup.component.html',
  styleUrls: ['./show-viewlog-popup.component.css'],
  standalone: true,
  imports: [EmrModalComponent, ShowViewlogComponent]
})
export class ShowViewlogPopupComponent implements OnInit {

  constructor(
    public bsShowViewLogModalRef: BsModalRef
  ) { }

  getHistoryTripRequest: GetHistoryTripRequest;

  ngOnInit() {
  }

  onPopupCancel() {
    this.bsShowViewLogModalRef.hide();
  }
}
